module.exports = __webpack_public_path__ + "img/_Lozz.2f182d4e.png";